import { render, staticRenderFns } from "./productionTaxTips.vue?vue&type=template&id=79829f14&scoped=true"
import script from "./productionTaxTips.vue?vue&type=script&lang=js"
export * from "./productionTaxTips.vue?vue&type=script&lang=js"
import style0 from "./productionTaxTips.vue?vue&type=style&index=0&id=79829f14&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79829f14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79829f14')) {
      api.createRecord('79829f14', component.options)
    } else {
      api.reload('79829f14', component.options)
    }
    module.hot.accept("./productionTaxTips.vue?vue&type=template&id=79829f14&scoped=true", function () {
      api.rerender('79829f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/productionTaxTips.vue"
export default component.exports